<label class="container">
    <input type="checkbox" [checked]="checked" [(ngModel)]="checked">
    <span class="checkmark"></span>
</label>